import React from 'react';

const VideoBackground = ({ videoUrl, fallbackImage }) => {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
      {/* Video Element - Supports both MP4 and WEBM */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        poster={fallbackImage}
      >
        <source src={videoUrl} type="video/webm" />
        <source src={videoUrl} type="video/mp4" />
        {/* Fallback to image if video doesn't load */}
        <img 
          src={fallbackImage}
          alt="Server Rack"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </video>
    </div>
  );
};

export default VideoBackground;
